import type { Translate } from "@/lib/i18n";

export type QuadrantKey = "quick-wins" | "big-bets" | "fill-ins" | "time-sinks";

export const QUADRANT_META: Record<
  QuadrantKey,
  {
    color: string;
    tint: number;
    half: { x: "left" | "right"; y: "top" | "bottom" };
  }
> = {
  "quick-wins": {
    color: "var(--chart-1)",
    tint: 0.02,
    half: { x: "left", y: "top" },
  },
  "big-bets": {
    color: "var(--chart-4)",
    tint: 0.04,
    half: { x: "right", y: "top" },
  },
  "fill-ins": {
    color: "var(--chart-2)",
    tint: 0.015,
    half: { x: "left", y: "bottom" },
  },
  "time-sinks": {
    color: "var(--chart-3)",
    tint: 0.015,
    half: { x: "right", y: "bottom" },
  },
};

export function quadrantLabel(key: QuadrantKey, t: Translate): string {
  switch (key) {
    case "quick-wins":
      return t("Quick wins");
    case "big-bets":
      return t("Big bets");
    case "fill-ins":
      return t("Fill-ins");
    case "time-sinks":
      return t("Time sinks");
  }
}

export function quadrantOf(effort: number, impact: number): QuadrantKey {
  if (impact >= 50 && effort < 50) return "quick-wins";
  if (impact >= 50 && effort >= 50) return "big-bets";
  if (impact < 50 && effort < 50) return "fill-ins";
  return "time-sinks";
}

export const QUADRANT_ORDER = Object.keys(QUADRANT_META) as QuadrantKey[];
